import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';

const states: Ng1StateDeclaration[] = [
    {
        component: 'wtValidatedState',
        name: 'validated',
        url: '/validated/:identifierGuid/:beginDate/:endDate',
        abstract: true,
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            dates: Resolve.datesResolve
        },
        params: {
            beginDate: '',
            endDate: '',
            identfierGuid: ''
        },
        redirectTo: 'validated.general',
        data: {
            visible: false,
            displayName: 'Identifiers',
            isAuthenticated: true,
            isConnected: true,
            editButtonVisibility: () => false,
            breadcrumbs: {
                level3StateName: 'identifiers',
                level4: ''
            }
        }
    }, {
        template: '<wt-validated-general class="flex-directive"></wt-validated-general>',
        name: 'validated.general',
        url: '/general',
        data: {
            displayName: 'Identifiers',
            isAuthenticated: true,
            isConnected: true,
            editButtonVisibility: () => false,
            breadcrumbs: {
                level3StateName: 'Identifier',
                level4: '',
                level5: 'General'
            }
        }
    }];

export default states;